var _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 210,
    viewBox: "0 0 256 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4681 159.962C36.1623 159.599 39.886 158.088 43.1552 156.334C46.4245 154.58 49.375 151.783 51.523 148.849C53.671 145.916 55.6065 142.287 56.3913 138.627C57.176 134.968 57.5064 131.067 57.1404 127.377C56.7744 123.687 55.2577 119.967 53.499 116.701C51.7403 113.434 48.9372 110.485 45.9983 108.338C43.0594 106.19 39.5303 104.602 35.7593 103.467C32.0946 102.681 28.188 102.348 24.6 103.058C23.9037 103.27 23.1011 103.133 22.5405 102.544C21.9798 101.954 21.4192 101.364 21.5549 100.563L20.6872 93.9846C20.1856 91.0963 20.7283 87.8905 22.2862 85.5166C23.7378 82.7948 25.7501 80.6628 28.4292 79.4685L158.675 16.3174C161.006 15.2289 163.201 14.9418 165.85 14.8967C168.152 14.9574 170.666 15.7137 172.59 17.0295L223.336 49.8788C225.153 50.8468 226.381 52.3743 227.608 53.9017C228.488 55.5349 229.473 57.5159 229.656 59.3608L240.794 136.936C241.16 140.626 240.376 144.286 238.228 147.219C236.08 150.152 232.569 152.36 228.874 152.722L47.4107 178.987C43.7165 179.349 40.0518 178.562 37.1129 176.415C34.174 174.267 31.961 170.759 31.595 167.069L31.1227 163.032C30.9102 162.336 31.046 161.534 31.6361 160.975C31.0755 160.385 31.7718 160.174 32.4681 159.962Z",
    fill: "url(#paint0_linear_336_52859)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4606 159.959C36.1549 159.597 39.8787 158.085 43.1481 156.331C46.4175 154.577 49.3681 151.78 51.5161 148.846C53.6642 145.912 55.5998 142.283 56.3846 138.624C57.1694 134.964 57.4997 131.062 57.1337 127.372C56.7677 123.683 55.2509 119.962 53.4922 116.696C51.3853 113.535 48.9302 110.48 45.9912 108.332C43.0522 106.184 39.523 104.596 35.7519 103.462C32.0871 102.675 28.1803 102.342 24.5922 103.052C23.8959 103.264 23.0932 103.128 22.5326 102.538C21.9719 101.948 21.4113 101.358 21.547 100.557L20.6793 93.9782C20.1776 91.0898 20.9328 88.5795 22.8389 86.0996C24.3969 83.7255 27.0762 82.531 29.9679 82.0323L218.372 54.7996C221.264 54.3008 223.778 55.0571 226.262 56.9628C228.641 58.5207 229.839 61.1975 230.34 64.0859L240.9 137.28C241.266 140.97 240.482 144.63 238.333 147.563C236.185 150.497 232.674 152.705 228.98 153.067L47.5099 179.333C43.8156 179.695 40.1508 178.909 37.2118 176.761C34.2728 174.613 32.0597 171.105 31.6937 167.415L31.2214 163.377C31.0089 162.681 31.1447 161.88 31.7348 161.32C31.0679 160.383 31.7642 160.171 32.4606 159.959Z",
    fill: "url(#paint1_linear_336_52859)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.269 123.526C196.241 125.367 184.138 116.325 182.408 103.705C180.678 91.0842 189.611 78.6145 202.25 76.8919C215.278 75.0512 227.382 84.0933 229.111 96.7135C230.841 109.334 222.297 121.685 209.269 123.526Z",
    fill: "url(#paint2_linear_336_52859)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.236 118.842C221.697 115.922 222.314 112.552 221.849 109.154C220.66 100.471 212.331 94.2498 203.366 95.5173C194.669 96.7034 188.521 105.284 189.71 113.967C189.941 115.651 190.44 117.243 191.16 118.705C186.522 115.101 183.246 109.824 182.408 103.707C180.679 91.0872 189.614 78.6172 202.254 76.8935C215.282 75.0515 227.386 84.0919 229.114 96.7114C230.288 105.281 226.724 113.726 220.236 118.842Z",
    fill: "url(#paint3_linear_336_52859)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.891 96.4648C146.26 97.645 138.914 92.279 138.077 84.5536C137.241 76.8283 142.264 69.601 150.001 68.7686C157.632 67.5884 164.979 72.9544 165.815 80.6798C167 88.2993 161.976 95.5265 153.891 96.4648Z",
    fill: "url(#paint4_linear_336_52859)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.592 79.3043C162.675 77.0577 158.858 75.958 154.967 76.5601C147.229 77.3933 142.205 84.6206 143.041 92.3455C143.091 92.8121 143.165 93.2701 143.262 93.7185C140.457 91.559 138.484 88.3398 138.074 84.5537C137.238 76.8289 142.263 69.6015 150.001 68.7683C157.171 67.6588 164.089 72.3282 165.592 79.3043Z",
    fill: "url(#paint5_linear_336_52859)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.851 150.952C168.067 151.951 162.645 147.9 161.991 142.019C160.988 136.244 165.044 130.831 170.934 130.18C176.717 129.181 182.14 133.232 182.794 139.113C183.796 144.888 179.741 150.301 173.851 150.952Z",
    fill: "url(#paint6_linear_336_52859)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182 136.124C180.533 135.682 178.941 135.566 177.32 135.845C171.43 136.497 167.374 141.91 168.375 147.685C168.493 148.747 168.767 149.749 169.17 150.673C165.401 149.537 162.46 146.252 161.99 142.019C160.988 136.245 165.044 130.832 170.935 130.18C175.674 129.362 180.171 131.933 182 136.124Z",
    fill: "url(#paint7_linear_336_52859)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2793 126.243C87.6959 131.676 90.4974 135.902 93.5318 135.64C96.5627 135.413 98.6458 130.828 98.2292 125.395C97.8127 119.962 95.0112 115.737 91.9768 115.999C88.9493 116.191 86.8628 120.811 87.2793 126.243Z",
    fill: "url(#paint8_radial_336_52859)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.012 122.52C135.428 127.952 138.23 132.178 141.264 131.916C144.295 131.689 146.378 127.104 145.962 121.671C145.545 116.239 142.744 112.013 139.709 112.275C136.682 112.467 134.595 117.087 135.012 122.52Z",
    fill: "url(#paint9_radial_336_52859)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.46 131.419C118.299 131.614 117.98 131.618 117.822 131.426C117.5 131.112 117.177 130.798 116.893 130.452C116.675 130.149 116.608 129.755 116.356 129.448C115.917 128.876 115.269 128.635 114.695 129.071C114.313 129.35 114.072 129.995 114.024 130.484C114.014 130.941 114.319 131.429 114.519 131.907C115.513 134.014 117.564 135.099 119.29 134.461C121.017 133.822 122.222 131.3 121.673 129.343C121.543 128.872 121.07 128.296 120.621 128.181C119.861 128 119.55 128.638 119.379 129.291C118.995 130.662 118.939 130.867 118.46 131.419Z",
    fill: "#984110"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_52859",
    x1: 64.8434,
    y1: 58.6729,
    x2: 340.374,
    y2: 11.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACC0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE67C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_52859",
    x1: 176.559,
    y1: 24.6992,
    x2: 21.8319,
    y2: 222.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_52859",
    x1: 198.866,
    y1: 77.6306,
    x2: 225.129,
    y2: 129.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_336_52859",
    x1: 200.51,
    y1: 94.285,
    x2: 216.28,
    y2: 126.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_336_52859",
    x1: 147.843,
    y1: 69.1786,
    x2: 159.182,
    y2: 100.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B42A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_336_52859",
    x1: 147.848,
    y1: 69.1767,
    x2: 159.196,
    y2: 100.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D06411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B42A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_336_52859",
    x1: 169.314,
    y1: 130.485,
    x2: 175.447,
    y2: 150.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B228"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_336_52859",
    x1: 169.319,
    y1: 130.484,
    x2: 175.46,
    y2: 150.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0600E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B228"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_336_52859",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.7655 125.812) rotate(175.562) scale(8.00654 7.97407)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#984110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3A0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_336_52859",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.486 122.086) rotate(175.562) scale(8.00654 7.97406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#984110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F3D0E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading3);
export default __webpack_public_path__ + "static/media/loading_3.b3790b299d814b02539916110cc42d54.svg";
export { ForwardRef as ReactComponent };